var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.336,
    height: 18.336,
    viewBox: "0 0 18.336 18.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.735,0H10.6a.857.857,0,0,1,.859.859V6.876H14.6a.715.715,0,0,1,.5,1.221L9.659,13.548a.694.694,0,0,1-.978,0L3.227,8.1a.715.715,0,0,1,.5-1.221H6.876V.859A.857.857,0,0,1,7.735,0Zm10.6,13.465v4.011a.857.857,0,0,1-.859.859H.859A.857.857,0,0,1,0,17.476V13.465a.857.857,0,0,1,.859-.859H6.113l1.755,1.755a1.835,1.835,0,0,0,2.6,0l1.755-1.755h5.254A.857.857,0,0,1,18.336,13.465ZM13.9,16.617a.716.716,0,1,0-.716.716A.718.718,0,0,0,13.9,16.617Zm2.292,0a.716.716,0,1,0-.716.716A.718.718,0,0,0,16.187,16.617Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6b1a81049b5eef14da025130d2f9d670.svg";
export { ForwardRef as ReactComponent };